export const CREATE_HEALTH_SURVEILLANCE_CASE = "CREATE_HEALTH_SURVEILLANCE_CASE";
export const CREATE_HEALTH_SURVEILLANCE_CASE_SUCCESS = "CREATE_HEALTH_SURVEILLANCE_CASE_SUCCESS";

export const LOAD_HEALTH_SURVEILLANCE_QUESTIONNAIRE = "LOAD_HEALTH_SURVEILLANCE_QUESTIONNAIRE";
export const LOADED_CLINIC_HEALTH_SURVEILLANCE_QUESTIONNAIRE = "LOADED_CLINIC_HEALTH_SURVEILLANCE_QUESTIONNAIRE";

export const DELETE_HEALTH_SURVEILLANCE_QUESTIONNAIRE_EVIDENCE = "DELETE_HEALTH_SURVEILLANCE_QUESTIONNAIRE_EVIDENCE";

export const DELETE_HEALTH_SURVEILLANCE_CONSULTATION_EVIDENCE = "DELETE_HEALTH_SURVEILLANCE_CONSULTATION_EVIDENCE";

export const SUBMIT_CLINIC_HEALTH_SURVEILLANCE_QUESTIONNAIRE_SUCCESS = "SUBMIT_CLINIC_HEALTH_SURVEILLANCE_QUESTIONNAIRE_SUCCESS";

export const LOAD_HEALTH_SURVEILLANCE_CONSULTATION = "LOAD_HEALTH_SURVEILLANCE_CONSULTATION";

export const LOAD_HEALTH_SURVEILLANCE_REPEAT_MEDICAL_CONSULTATION = "LOAD_HEALTH_SURVEILLANCE_REPEAT_MEDICAL_CONSULTATION";

export const SUBMIT_CLINIC_HEALTH_SURVEILLANCE_CONSULTATION_SUCCESS = "SUBMIT_CLINIC_HEALTH_SURVEILLANCE_CONSULTATION_SUCCESS";

export const SUBMIT_CLINIC_HEALTH_SURVEILLANCE_REPEAT_CONSULTATION_SUCCESS = "SUBMIT_CLINIC_HEALTH_SURVEILLANCE_REPEAT_CONSULTATION_SUCCESS";

export const SEND_HEALTH_SURVEILLANCE_QUESTIONNAIRE = "SEND_HEALTH_SURVEILLANCE_QUESTIONNAIRE";

export const COMPLETE_NOW_HEALTH_SURVEILLANCE_QUESTIONNAIRE = "COMPLETE_NOW_HEALTH_SURVEILLANCE_QUESTIONNAIRE";

export const ACTION_FURTHER_INFORMATION_AND_REVIEW_OF_FITNESS = "ACTION_FURTHER_INFORMATION_AND_REVIEW_OF_FITNESS";
